'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Apollo = require('@apollo/client');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var Apollo__namespace = /*#__PURE__*/_interopNamespace(Apollo);

const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */

/** Address represents the information Narvar has about an address. */

/** AddressInput specifies information you have about an address. */

/** AvailableReturnDropOff details teh available options allowed for a DROP_OFF PUDO Option. */

/** AvailableReturnItemReason specifies an item reason that is available to be used. */

/** AvailableReturnPickup details the available options allowed for a PICK_UP PUDO Option. */

/** CommentSettings represents the settings for a comment. */

/** Represent a Coordinate on Earth */

/** Represents an amount of a specific currency. */

/** Represents an amount of a specific currency. */

/** Customer details the information Narvar has about the customer. */

/** CustomerInput details the information you have about the customer. */

/** DayOfWeek represents a given day of the week. */

/** Distance represents a real world distance between two points. */

/** DistanceUnit represents a particular unit of distance. */

/** The types of return the item is eligible for. */

/** Eligibility governs whether or not an item is eligible. */

/** Fee represents costs the customer must either pay, or will be subtracted from their return. */

/** FeeInput represents an input of costs the customer must either pay, or will be subtracted from their return. */

/** FeeType represents what type the fee is. */

/** HandoffType specifies how the pickup agent will pickup the return. */

/** Location represents a location that can perform a PUDOOption's service. */

/**
 * LocationInput is the input that corresponds to Location.
 * I.E. a physical location that can provide service for a PUDO Option
 */

/** Address for fetching nearby locations */

/** LocationQueryInput is represents the input for fetching available locations for a PUDO option */

/** LocationSortOption represents the options available for sorting the locations. */

/**
 * Narvar Pudo Instructions are lower level directives to Narvar with additional
 * details on the how to handle the PUDO Option.
 */

/**
 * Narvar Pudo Instructions are lower level directives to Narvar with additional
 * details on the how to handle the PUDO Option.
 */

/** OpeningHours specify the days of the week and hours on those days that a location is open for business. */

/** Order represents the information Narvar has about the order in the Order Locator. */

/** OrderItems represents the information Narvar has about a line item in the Order. */

/** PickupTimeSlot describes the selected time-slot of the pickup. */

/** PickupTimeSlotInput is used to describe a time-slot the customer has selected. */

/**
 * Pudo Action Type is whether or not the customer is dropping something off,
 * or a carrier is coming to pick something up from them.
 */

/**
 * PudoActionType details describe what the customer has to have or do
 * to perform the pudo action
 */

/** PudoOption describes an option the customer may select to have the return Picked-Up or Dropped-Off (PUDO). */

/**
 * PudoOptionInput describes the PUDO Option the user wants to use.
 * I.E. It's the input type for PudoOption with all editable fields represented.
 * If the PudoOption input is not valid given the contents of the return cart,
 * an error will be returned.
 */

/** PudoProvider represents a service provider for a PUDO Option. */

/** PudoProvider represents a service provider for a PUDO Option. */

/** PudoProviderType specifies the type of provider of a PUDO option. */

/** Represents the refund amounts, taxes, fees etc on a submitted return. */

/** RefundOption describes the options that are available to a customer to receive their refund amount. */

/**
 * RefundOptionInput is used to describe a selected Refund option when setting it on the cart.
 * All fields except ID will be ignored if provided
 */

/** RefundType specifies the type of the Refund Option. */

/** Represents the action the user needs to do for a particular item */

/** ReturnActionType describes what the customer can do with the item and how it gets back to the retailer. */

/**
 * ReturnCart represents the server's view of what a cart contains.
 * Until submitted, it is primarily used to communicate the cart's ID.
 */

/** A Return Cart represents the items selected for return, along with any PUDO or other options selected. */

/** ReturnDropOffInput is used to specify which drop-off options the customer selected. */

/** ReturnItem specifies Narvar's view of an item that was returned. */

/** ReturnItemInput represents the information you have about an item being returned. */

/** ReturnLabel describes the information about a label that must be placed on or in the return. */

/** ReturnLabelType specifies the type of the Return Label. */

/** ReturnPickupInput is used to specify which pickup options the customer selected. */

/** ReturnShipment describes a shipment, including label and items to be returned. */

/** ReturnTracking specifies tracking information about the ReturnShipment. */

/** PudoOption describes the pudo option the user actually selected. */

/** ReturnDropOff describes a drop off location and instructions for an return. */

/** SelectedReturnItemReason specifies the ReturnItemReason ID the customer selected. */

/** SelectedReturnItemReasonInput specifies the ReturnItemReason ID the customer selected. */

/** ReturnPickup details the options the customer selected for a PICKUP. */

/** SortedLocation represents a list of locations that can perform a PUDOOption's service, sorted in a particular order */

/** SubmittedReturn describes a submitted Return. */

/** SubmittedReturnStatus indicates what status the submitted return is currently in. */

const CustomerFragmentDoc = Apollo.gql`
  fragment Customer on Customer {
    __typename
    firstName
    lastName
    fullName
    billingAddress {
      address1
      address2
      city
      regionCode
      postalCode
      countryCode
    }
    shippingAddress {
      address1
      address2
      city
      regionCode
      postalCode
      countryCode
    }
    pickupAddress {
      address1
      address2
      city
      regionCode
      postalCode
      countryCode
    }
    email
    phone
  }
`;
const OrderFragmentDoc = Apollo.gql`
  fragment Order on Order {
    __typename
    orderId
    orderDate
    items {
      name
      quantity
      remainingQuantity
      orderedQuantity
      price {
        value
        currency
      }
      description
      eligibilities {
        exchange {
          isEligible
          message
        }
        repair {
          isEligible
          message
        }
        return {
          isEligible
          message
        }
      }
      sku
      color
      size
      itemId
      imageUrl
      additionalProperties {
        name
        value
      }
      availableReasons {
        id
        name
        childIds
        comments {
          allowed
          required
        }
      }
      availableReturnActions {
        type
        destination {
          address1
          address2
          city
          regionCode
          postalCode
          countryCode
        }
        returnDeadline
      }
    }
  }
`;
const PudoOptionBaseFragmentDoc = Apollo.gql`
  fragment PudoOptionBase on SelectedPudoOption {
    __typename
    pudoActionType
    pudoActionTypeDetails
    pudoProvider {
      type
      iconUrl
      moniker
    }
    title
    description
    fees {
      type
      amount {
        value
        currency
      }
    }
    serviceType
    discounts {
      value
      currency
    }
    narvarPudoInstructions {
      narvarCnsId
    }
  }
`;
const SelectedDropoffFragmentDoc = Apollo.gql`
  fragment SelectedDropoff on SelectedPudoOption {
    selectedDropOff {
      dropOffLocation {
        id
        storeId
        storeName
        displayName
        brand
        companyName
        locationType
        distance {
          value
          unit
        }
        latitude
        longitude
        phoneNumber
        address {
          address1
          address2
          city
          regionCode
          postalCode
          countryCode
        }
        openingHours {
          day
          hours
        }
        openingHoursDisplayString
        logoUrls
      }
      dropOffInstructions
      storeDirections
    }
  }
`;
const PudoOptionFragmentDoc = Apollo.gql`
  fragment PudoOption on SubmittedReturn {
    pudoOption {
      ...PudoOptionBase
      ...SelectedDropoff
      selectedPickup {
        selectedHandoff
        customerInstructions
      }
    }
  }
  ${PudoOptionBaseFragmentDoc}
  ${SelectedDropoffFragmentDoc}
`;
const HipaaPudoOptionFragmentDoc = Apollo.gql`
  fragment HipaaPudoOption on SubmittedReturn {
    pudoOption {
      ...PudoOptionBase
      ...SelectedDropoff
      selectedPickup {
        selectedHandoff
      }
    }
  }
  ${PudoOptionBaseFragmentDoc}
  ${SelectedDropoffFragmentDoc}
`;
const ReturnFragmentDoc = Apollo.gql`
  fragment Return on SubmittedReturn {
    __typename
    id
    status
    rmaNumber
    canBeCancelled
    shippingLabelInfoToken
    returnActions {
      type
      destination {
        address1
        address2
        city
        regionCode
        postalCode
        countryCode
      }
      returnDeadline
    }
    returnShipments {
      returnLabels {
        labelType
        mimeType
        labelUrl
      }
      items {
        id
        name
        quantity
        price {
          value
          currency
        }
        variant
        reason {
          id
          name
        }
        customerComments
        itemId
        sku
        color
        size
        categories
        imageUrl
        addedAt
        returnAction {
          type
          returnDeadline
        }
      }
      returnTracking {
        carrierName
        carrierMoniker
        trackingNumber
        narvarTrackingUrl
      }
    }
    refundInfo {
      taxes {
        value
        currency
      }
      refundSubTotal {
        value
        currency
      }
      estimatedRefund {
        value
        currency
      }
    }
  }
`;
const CommonReturnCartFieldsFragmentDoc = Apollo.gql`
  fragment CommonReturnCartFields on ReturnCart {
    id
    items {
      id
      name
      quantity
      price {
        value
        currency
      }
      variant
      reason {
        id
        name
      }
      customerComments
      itemId
      sku
      color
      size
      categories
      imageUrl
      addedAt
      returnAction {
        type
        destination {
          address1
          address2
          city
          regionCode
          postalCode
          countryCode
        }
        returnDeadline
      }
    }
    createdDate
    expirationDate
    lastUpdatedDate
    pudoOption {
      ...PudoOptionBase
    }
    retailerMoniker
    orderId
  }
  ${PudoOptionBaseFragmentDoc}
`;
const CommonPudoOptionFieldsFragmentDoc = Apollo.gql`
  fragment CommonPudoOptionFields on ReturnCart {
    id
    items {
      id
      name
      quantity
      price {
        value
        currency
      }
      variant
      reason {
        id
        name
      }
      customerComments
      itemId
      sku
      color
      size
      categories
      imageUrl
      addedAt
      returnAction {
        type
        destination {
          address1
          address2
          city
          regionCode
          postalCode
          countryCode
        }
        returnDeadline
      }
    }
    createdDate
    expirationDate
    lastUpdatedDate
    retailerMoniker
    orderId
  }
`;
const CancelSubmittedReturnDocument = Apollo.gql`
  mutation CancelSubmittedReturn($returnId: ID!) {
    cancelSubmittedReturn(returnId: $returnId) {
      id
      status
    }
  }
`;
/**
 * __useCancelSubmittedReturnMutation__
 *
 * To run a mutation, you first call `useCancelSubmittedReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubmittedReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubmittedReturnMutation, { data, loading, error }] = useCancelSubmittedReturnMutation({
 *   variables: {
 *      returnId: // value for 'returnId'
 *   },
 * });
 */
function useCancelSubmittedReturnMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(CancelSubmittedReturnDocument, options);
}
const CreateReturnCartDocument = Apollo.gql`
  mutation CreateReturnCart($initialReturnCart: ReturnCartInput!) {
    createReturnCart(initialReturnCart: $initialReturnCart) {
      ...CommonReturnCartFields
      customer {
        ...Customer
      }
    }
  }
  ${CommonReturnCartFieldsFragmentDoc}
  ${CustomerFragmentDoc}
`;
/**
 * __useCreateReturnCartMutation__
 *
 * To run a mutation, you first call `useCreateReturnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReturnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReturnCartMutation, { data, loading, error }] = useCreateReturnCartMutation({
 *   variables: {
 *      initialReturnCart: // value for 'initialReturnCart'
 *   },
 * });
 */
function useCreateReturnCartMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(CreateReturnCartDocument, options);
}
const HipaaCreateReturnCartDocument = Apollo.gql`
  mutation HipaaCreateReturnCart($initialReturnCart: ReturnCartInput!) {
    createReturnCart(initialReturnCart: $initialReturnCart) {
      ...CommonReturnCartFields
    }
  }
  ${CommonReturnCartFieldsFragmentDoc}
`;
/**
 * __useHipaaCreateReturnCartMutation__
 *
 * To run a mutation, you first call `useHipaaCreateReturnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHipaaCreateReturnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hipaaCreateReturnCartMutation, { data, loading, error }] = useHipaaCreateReturnCartMutation({
 *   variables: {
 *      initialReturnCart: // value for 'initialReturnCart'
 *   },
 * });
 */
function useHipaaCreateReturnCartMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(HipaaCreateReturnCartDocument, options);
}
const EmailSubmittedReturnDetailsDocument = Apollo.gql`
  mutation EmailSubmittedReturnDetails($returnId: ID!, $emailAddress: String!) {
    emailSubmittedReturnDetails(
      returnId: $returnId
      emailAddress: $emailAddress
    ) {
      id
      status
    }
  }
`;
/**
 * __useEmailSubmittedReturnDetailsMutation__
 *
 * To run a mutation, you first call `useEmailSubmittedReturnDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailSubmittedReturnDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailSubmittedReturnDetailsMutation, { data, loading, error }] = useEmailSubmittedReturnDetailsMutation({
 *   variables: {
 *      returnId: // value for 'returnId'
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
function useEmailSubmittedReturnDetailsMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(EmailSubmittedReturnDetailsDocument, options);
}
const SetPudoOptionDocument = Apollo.gql`
  mutation SetPudoOption($returnCartId: ID!, $pudoOption: PudoOptionInput!) {
    setPudoOption(returnCartId: $returnCartId, pudoOption: $pudoOption) {
      ...CommonPudoOptionFields
      customer {
        ...Customer
      }
      pudoOption {
        ...PudoOptionBase
        ...SelectedDropoff
        selectedPickup {
          selectedTimeSlot {
            earliestArrival
            latestArrival
          }
          selectedHandoff
          customerInstructions
        }
      }
    }
  }
  ${CommonPudoOptionFieldsFragmentDoc}
  ${CustomerFragmentDoc}
  ${PudoOptionBaseFragmentDoc}
  ${SelectedDropoffFragmentDoc}
`;
/**
 * __useSetPudoOptionMutation__
 *
 * To run a mutation, you first call `useSetPudoOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPudoOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPudoOptionMutation, { data, loading, error }] = useSetPudoOptionMutation({
 *   variables: {
 *      returnCartId: // value for 'returnCartId'
 *      pudoOption: // value for 'pudoOption'
 *   },
 * });
 */
function useSetPudoOptionMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(SetPudoOptionDocument, options);
}
const HipaaSetPudoOptionDocument = Apollo.gql`
  mutation HipaaSetPudoOption(
    $returnCartId: ID!
    $pudoOption: PudoOptionInput!
  ) {
    setPudoOption(returnCartId: $returnCartId, pudoOption: $pudoOption) {
      ...CommonPudoOptionFields
      pudoOption {
        ...PudoOptionBase
        ...SelectedDropoff
        selectedPickup {
          selectedTimeSlot {
            earliestArrival
            latestArrival
          }
          selectedHandoff
        }
      }
    }
  }
  ${CommonPudoOptionFieldsFragmentDoc}
  ${PudoOptionBaseFragmentDoc}
  ${SelectedDropoffFragmentDoc}
`;
/**
 * __useHipaaSetPudoOptionMutation__
 *
 * To run a mutation, you first call `useHipaaSetPudoOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHipaaSetPudoOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hipaaSetPudoOptionMutation, { data, loading, error }] = useHipaaSetPudoOptionMutation({
 *   variables: {
 *      returnCartId: // value for 'returnCartId'
 *      pudoOption: // value for 'pudoOption'
 *   },
 * });
 */
function useHipaaSetPudoOptionMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(HipaaSetPudoOptionDocument, options);
}
const SubmitReturnCartDocument = Apollo.gql`
  mutation SubmitReturnCart($returnCartId: ID!) {
    submitReturnCart(returnCartId: $returnCartId) {
      ...Return
      customer {
        ...Customer
      }
      pudoOption {
        ...PudoOptionBase
        ...SelectedDropoff
        selectedPickup {
          selectedHandoff
          customerInstructions
        }
      }
    }
  }
  ${ReturnFragmentDoc}
  ${CustomerFragmentDoc}
  ${PudoOptionBaseFragmentDoc}
  ${SelectedDropoffFragmentDoc}
`;
/**
 * __useSubmitReturnCartMutation__
 *
 * To run a mutation, you first call `useSubmitReturnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitReturnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitReturnCartMutation, { data, loading, error }] = useSubmitReturnCartMutation({
 *   variables: {
 *      returnCartId: // value for 'returnCartId'
 *   },
 * });
 */
function useSubmitReturnCartMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(SubmitReturnCartDocument, options);
}
const HipaaSubmitReturnCartDocument = Apollo.gql`
  mutation HipaaSubmitReturnCart($returnCartId: ID!, $mailTo: String) {
    submitReturnCart(returnCartId: $returnCartId, mailTo: $mailTo) {
      ...Return
      pudoOption {
        ...PudoOptionBase
        ...SelectedDropoff
        selectedPickup {
          selectedHandoff
        }
      }
    }
  }
  ${ReturnFragmentDoc}
  ${PudoOptionBaseFragmentDoc}
  ${SelectedDropoffFragmentDoc}
`;
/**
 * __useHipaaSubmitReturnCartMutation__
 *
 * To run a mutation, you first call `useHipaaSubmitReturnCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHipaaSubmitReturnCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hipaaSubmitReturnCartMutation, { data, loading, error }] = useHipaaSubmitReturnCartMutation({
 *   variables: {
 *      returnCartId: // value for 'returnCartId'
 *      mailTo: // value for 'mailTo'
 *   },
 * });
 */
function useHipaaSubmitReturnCartMutation(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useMutation(HipaaSubmitReturnCartDocument, options);
}
const GetLocationsDocument = Apollo.gql`
  query GetLocations($returnCartId: ID!, $locationQuery: LocationQueryInput) {
    getLocations(returnCartId: $returnCartId, locationQuery: $locationQuery) {
      id
      storeId
      storeName
      displayName
      brand
      companyName
      locationType
      distance {
        value
        unit
      }
      latitude
      longitude
      phoneNumber
      address {
        address1
        address2
        city
        regionCode
        postalCode
        countryCode
      }
      openingHours {
        day
        hours
      }
      openingHoursDisplayString
      logoUrls
    }
  }
`;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      returnCartId: // value for 'returnCartId'
 *      locationQuery: // value for 'locationQuery'
 *   },
 * });
 */
function useGetLocationsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetLocationsDocument, options);
}
function useGetLocationsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetLocationsDocument, options);
}
const GetOrderInfoAndSubmittedReturnsDocument = Apollo.gql`
  query GetOrderInfoAndSubmittedReturns($orderId: String!) {
    getOrderInfo(orderId: $orderId) {
      ...Order
    }
    getSubmittedReturnsForOrder(orderId: $orderId) {
      ...Return
      ...PudoOption
      customer {
        ...Customer
      }
    }
  }
  ${OrderFragmentDoc}
  ${ReturnFragmentDoc}
  ${PudoOptionFragmentDoc}
  ${CustomerFragmentDoc}
`;

/**
 * __useGetOrderInfoAndSubmittedReturnsQuery__
 *
 * To run a query within a React component, call `useGetOrderInfoAndSubmittedReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderInfoAndSubmittedReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderInfoAndSubmittedReturnsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
function useGetOrderInfoAndSubmittedReturnsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetOrderInfoAndSubmittedReturnsDocument, options);
}
function useGetOrderInfoAndSubmittedReturnsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetOrderInfoAndSubmittedReturnsDocument, options);
}
const HipaaGetOrderInfoAndSubmittedReturnsDocument = Apollo.gql`
  query HipaaGetOrderInfoAndSubmittedReturns($orderId: String!) {
    getOrderInfo(orderId: $orderId) {
      ...Order
      hasAssociatedEmail
    }
    getSubmittedReturnsForOrder(orderId: $orderId) {
      ...Return
      ...HipaaPudoOption
    }
  }
  ${OrderFragmentDoc}
  ${ReturnFragmentDoc}
  ${HipaaPudoOptionFragmentDoc}
`;

/**
 * __useHipaaGetOrderInfoAndSubmittedReturnsQuery__
 *
 * To run a query within a React component, call `useHipaaGetOrderInfoAndSubmittedReturnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHipaaGetOrderInfoAndSubmittedReturnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHipaaGetOrderInfoAndSubmittedReturnsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
function useHipaaGetOrderInfoAndSubmittedReturnsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(HipaaGetOrderInfoAndSubmittedReturnsDocument, options);
}
function useHipaaGetOrderInfoAndSubmittedReturnsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(HipaaGetOrderInfoAndSubmittedReturnsDocument, options);
}
const GetPudoOptionsDocument = Apollo.gql`
  query GetPudoOptions($returnCartId: ID!) {
    getPudoOptions(returnCartId: $returnCartId) {
      pudoActionType
      pudoActionTypeDetails
      pudoProvider {
        type
        iconUrl
        moniker
      }
      title
      description
      fees {
        type
        amount {
          value
          currency
        }
      }
      dropOff {
        locations {
          id
          storeId
          storeName
          displayName
          brand
          companyName
          locationType
          distance {
            value
            unit
          }
          latitude
          longitude
          phoneNumber
          address {
            address1
            address2
            city
            regionCode
            postalCode
            countryCode
          }
          openingHours {
            day
            hours
          }
          openingHoursDisplayString
          logoUrls
        }
        sortedLocations {
          locationsList {
            id
            storeId
            storeName
            displayName
            brand
            companyName
            locationType
            distance {
              value
              unit
            }
            latitude
            longitude
            phoneNumber
            address {
              address1
              address2
              city
              regionCode
              postalCode
              countryCode
            }
            openingHours {
              day
              hours
            }
            openingHoursDisplayString
            logoUrls
          }
          sortedBy
          availableSortOptions
        }
        externalStoreLocatorUrl
      }
      pickup {
        timeSlots {
          earliestArrival
          latestArrival
        }
        handoffTypes
      }
      serviceType
      discounts {
        value
        currency
      }
      narvarPudoInstructions {
        narvarCnsId
      }
    }
  }
`;

/**
 * __useGetPudoOptionsQuery__
 *
 * To run a query within a React component, call `useGetPudoOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPudoOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPudoOptionsQuery({
 *   variables: {
 *      returnCartId: // value for 'returnCartId'
 *   },
 * });
 */
function useGetPudoOptionsQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetPudoOptionsDocument, options);
}
function useGetPudoOptionsLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetPudoOptionsDocument, options);
}
const GetShippingLabelInfoDocument = Apollo.gql`
  query GetShippingLabelInfo(
    $shippingLabelInfoToken: String!
    $retailerMoniker: String!
  ) {
    getShippingLabelInfo(
      shippingLabelInfoToken: $shippingLabelInfoToken
      retailerMoniker: $retailerMoniker
    ) {
      carrierMoniker
      returnLabels {
        labelType
        mimeType
        labelUrl
      }
      items {
        id
        name
        quantity
        price {
          value
          currency
        }
        reason {
          id
          name
        }
        imageUrl
        sku
        color
        size
      }
      selectedPudoOption {
        pudoActionType
        pudoActionTypeDetails
        pudoProvider {
          type
          moniker
        }
        selectedDropOff {
          dropOffLocation {
            id
            storeName
            displayName
            brand
            companyName
            distance {
              value
              unit
            }
            phoneNumber
            address {
              address1
              address2
              city
              regionCode
              postalCode
              countryCode
            }
            openingHoursDisplayString
            logoUrls
          }
          dropOffInstructions
          storeDirections
        }
      }
      obfuscatedCustomer {
        email
      }
    }
  }
`;

/**
 * __useGetShippingLabelInfoQuery__
 *
 * To run a query within a React component, call `useGetShippingLabelInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingLabelInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingLabelInfoQuery({
 *   variables: {
 *      shippingLabelInfoToken: // value for 'shippingLabelInfoToken'
 *      retailerMoniker: // value for 'retailerMoniker'
 *   },
 * });
 */
function useGetShippingLabelInfoQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useQuery(GetShippingLabelInfoDocument, options);
}
function useGetShippingLabelInfoLazyQuery(baseOptions) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo__namespace.useLazyQuery(GetShippingLabelInfoDocument, options);
}

exports.CancelSubmittedReturnDocument = CancelSubmittedReturnDocument;
exports.CommonPudoOptionFieldsFragmentDoc = CommonPudoOptionFieldsFragmentDoc;
exports.CommonReturnCartFieldsFragmentDoc = CommonReturnCartFieldsFragmentDoc;
exports.CreateReturnCartDocument = CreateReturnCartDocument;
exports.CustomerFragmentDoc = CustomerFragmentDoc;
exports.EmailSubmittedReturnDetailsDocument = EmailSubmittedReturnDetailsDocument;
exports.GetLocationsDocument = GetLocationsDocument;
exports.GetOrderInfoAndSubmittedReturnsDocument = GetOrderInfoAndSubmittedReturnsDocument;
exports.GetPudoOptionsDocument = GetPudoOptionsDocument;
exports.GetShippingLabelInfoDocument = GetShippingLabelInfoDocument;
exports.HipaaCreateReturnCartDocument = HipaaCreateReturnCartDocument;
exports.HipaaGetOrderInfoAndSubmittedReturnsDocument = HipaaGetOrderInfoAndSubmittedReturnsDocument;
exports.HipaaPudoOptionFragmentDoc = HipaaPudoOptionFragmentDoc;
exports.HipaaSetPudoOptionDocument = HipaaSetPudoOptionDocument;
exports.HipaaSubmitReturnCartDocument = HipaaSubmitReturnCartDocument;
exports.OrderFragmentDoc = OrderFragmentDoc;
exports.PudoOptionBaseFragmentDoc = PudoOptionBaseFragmentDoc;
exports.PudoOptionFragmentDoc = PudoOptionFragmentDoc;
exports.ReturnFragmentDoc = ReturnFragmentDoc;
exports.SelectedDropoffFragmentDoc = SelectedDropoffFragmentDoc;
exports.SetPudoOptionDocument = SetPudoOptionDocument;
exports.SubmitReturnCartDocument = SubmitReturnCartDocument;
exports.useCancelSubmittedReturnMutation = useCancelSubmittedReturnMutation;
exports.useCreateReturnCartMutation = useCreateReturnCartMutation;
exports.useEmailSubmittedReturnDetailsMutation = useEmailSubmittedReturnDetailsMutation;
exports.useGetLocationsLazyQuery = useGetLocationsLazyQuery;
exports.useGetLocationsQuery = useGetLocationsQuery;
exports.useGetOrderInfoAndSubmittedReturnsLazyQuery = useGetOrderInfoAndSubmittedReturnsLazyQuery;
exports.useGetOrderInfoAndSubmittedReturnsQuery = useGetOrderInfoAndSubmittedReturnsQuery;
exports.useGetPudoOptionsLazyQuery = useGetPudoOptionsLazyQuery;
exports.useGetPudoOptionsQuery = useGetPudoOptionsQuery;
exports.useGetShippingLabelInfoLazyQuery = useGetShippingLabelInfoLazyQuery;
exports.useGetShippingLabelInfoQuery = useGetShippingLabelInfoQuery;
exports.useHipaaCreateReturnCartMutation = useHipaaCreateReturnCartMutation;
exports.useHipaaGetOrderInfoAndSubmittedReturnsLazyQuery = useHipaaGetOrderInfoAndSubmittedReturnsLazyQuery;
exports.useHipaaGetOrderInfoAndSubmittedReturnsQuery = useHipaaGetOrderInfoAndSubmittedReturnsQuery;
exports.useHipaaSetPudoOptionMutation = useHipaaSetPudoOptionMutation;
exports.useHipaaSubmitReturnCartMutation = useHipaaSubmitReturnCartMutation;
exports.useSetPudoOptionMutation = useSetPudoOptionMutation;
exports.useSubmitReturnCartMutation = useSubmitReturnCartMutation;
